const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;

import axiosInstance from "utils/axiosInstance";

function buildURL(path, params = {}) {
  const searchParams = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, val]) => {
      if (val !== undefined && val !== null) acc[key] = String(val);
      return acc;
    }, {})
  );
  return `${BASE_URL}${path}${searchParams.toString() ? `?${searchParams}` : ""}`;
}



// Obtener sesiones activas
export async function getCartSessionsClient({ current = false, limit = 10 } = {}) {
  const url = buildURL("/api/cart-sessions", { current, limit });
  console.log("Fetching cart sessions from:", url);
  const data = await axiosInstance({ method: 'GET', url });
  return data.data;
}

// Crear nueva sesión
export async function createCartSessionClient() {
  const url = "/api/cart-sessions";
  const data = await axiosInstance({ method: "POST", url });
  return data.data;
}

// Obtener sesión por ID
export async function getCartSessionByIdClient() {
  const url = `/api/cart-sessions`;
  const data = await axiosInstance({ method: "GET", url, params: { current: true } });
  return data.data;
}

// Agregar producto
export async function addProductToSessionClient(sessionId, { product_id, price, quantity }) {
  const url = `/api/cart-sessions/${sessionId}/add-product`;
  const data = await axiosInstance({ method: "POST", url, data: { product_id, price, quantity } });
  return data.data;
}

// Actualizar producto
export async function updateProductInSessionClient(cartId, { product_id, price, quantity }) {
  const url = buildURL(`/api/cart-sessions/${cartId}/update-product`);
  const data = await axiosInstance({ method: "PUT", url, data: { product_id, price, quantity } });
  return data.data;
}

// Eliminar producto
export async function deleteProductFromSessionClient(cartId) {
  const url = `/api/cart-sessions/${cartId}`
  const data = await axiosInstance({ method: "DELETE", url });

  return data.data;
}

export async function syncProductInSessionClient(cartId, items) {
  const url = `/api/cart-sessions/${cartId}/sync`;
  const data = await axiosInstance({ method: "PUT", url, data: { "products": items  } });
  return data;
}


export async function downloadStatementClient() {
  const url = `/api/user/statement`;
  const response = await axiosInstance({
    method: "POST",
    url,
    responseType: "blob",
  });
  return response.data;
}


export default {
  getCartSessionsClient,
  createCartSessionClient,
  getCartSessionByIdClient,
  addProductToSessionClient,
  updateProductInSessionClient,
  deleteProductFromSessionClient,
  syncProductInSessionClient,
  downloadStatementClient
};
